import '../../css/style.scss'
import {Sound} from '../../../shared/scripts/Sound'
import {UIWHeaderController} from '../ui_html/header/UIWHeaderController'
import {UISidebarController} from '../ui_html/sidebar/UISidebarController'
import {EntryShared} from '../../../shared/scripts/EntryShared'
import {UISingletonScrollController} from '../../../shared/scripts/ui_scroll_controller/UISingletonScrollController'
import {EntrySingletonPageShared} from '../../EntrySingletonPageShared'

void init()

async function init() {
    Sound.loadSounds()

    await EntryShared.initializeEntry()

    const headerController = new UIWHeaderController()
    new UISidebarController()

    new UISingletonScrollController()

    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
    EntryShared.sendPageVisitAnalyticEvent()
}
